import React from "react";
import { useHasPermission } from "../../auth/useClaims";
import { useBranchFilter } from "../../branchFilter/useBranchFilter";
import { useGetPettyCashFundsQuery } from "../../pettycash/pettyCashApi";
import { money, sumBy } from "../dashboardHelpers";
import DashboardSectionCard from "../components/DashboardSectionCard";

const PettyCashByBranchCard = () => {
  const canView = useHasPermission("PettyCash.ViewBalance");
  const { selectedBranchId } = useBranchFilter();

  const { data: funds, isFetching } = useGetPettyCashFundsQuery(
    { isActive: true, branchId: selectedBranchId ?? undefined },
    { skip: !canView }
  );

  if (!canView) return null;

  const map = new Map();
  (funds || []).forEach((f) => map.set(f.branchCode, (map.get(f.branchCode) || 0) + Number(f.currentBalance || 0)));
  const branchBalances = [...map.entries()].map(([branchCode, total]) => ({ branchCode, total }));
  const grandTotal = sumBy(funds, "currentBalance");

  return (
    <div className="col-12 col-xl-4">
      <DashboardSectionCard title="Petty Cash by Branch" headerRight="Balance" isLoading={isFetching} isEmpty={branchBalances.length === 0}>
        <ul className="list-unstyled mb-2">
          {branchBalances.map((b) => (
            <li key={b.branchCode} className="d-flex justify-content-between mb-2">
              <span className="small fw-semibold">{b.branchCode}</span>
              <span>{money(b.total)}</span>
            </li>
          ))}
        </ul>
        <hr className="my-2" />
        <div className="d-flex justify-content-between">
          <span className="fw-semibold">Total Petty Cash</span>
          <span className="fw-bold text-danger">{money(grandTotal)}</span>
        </div>
      </DashboardSectionCard>
    </div>
  );
};

export default PettyCashByBranchCard;
